import NodeHelper from '../../../helpers/node_helper'
import AbstractField from '../abstract'

import './style.css'


function _cast(type, value){
    switch (type){
        case 'string':
            value = String(value)
            break;
        case 'boolean':
            value = (value == 'true' ? true : false)
            break;
        case 'number':
            value = Number(value)
            break;
        default:
            break;
    }
    return value
}

class RadioField extends AbstractField{
    __init_dom_schema(){
        return {
            input: {
                selector: 'input[type="radio"]',
            },
            switch: {
                selector: '.js-switch',
                actions: {
                    'click': this.onSwitchClick.bind(this)
                }
            }
        }
    }
    __init(){
        const initial_type = this.dom.input.getAttribute('data-initial-type')
        if(initial_type){
            this.value = _cast(initial_type, this.dom.input.value)
        }else{
            this.value = this.dom.input.value
        }
        this.registerEvents('changed')
    }
    onSwitchClick(event){
        this.dom.input.checked = true
        this.applySwitcher()        
        this.dispatchEvent('changed')
    }
    applySwitcher(){
        NodeHelper.ToggleClass(
            this.dom.switch, 
            '-active',
            this.dom.input.checked
        )
    }
    isRequired(){
        return this.dom.input.hasAttribute('required')
    }
    isFilled(){
        return this.dom.input.checked
    }
    getValue(){
        return this.value
    }
    setValue(value){
        if(this.value == value){
            this.dom.input.checked = true
        }else{
            this.dom.input.checked = false
        }
        this.applySwitcher()
    }
}

export default RadioField